export default __webpack_public_path__ + "static/media/03_tag_paid-parking.d80e84e9.svg";